import { Entity } from '@adornis/baseql/decorators.js';
import { KooperationsPartner } from './KooperationsPartner.js';
import { School } from './School.js';

/**
 * @entity ChancenSchule
 */

@Entity()
export class ChancenSchule extends School {
  public static override _class = 'ChancenSchule';

  public override get type() {
    return KooperationsPartner.CHANCENSCHULE;
  }
}
